import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import {
  commonPostPutApi,
  commonPostPutFormData,
} from "../../../redux/reducers/commonApiSlice";
import {
  add_staff_cto,
  delete_user,
  update_staff_register,
  update_trainer,
} from "../../../data/ApiEndpoints";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { convertTo12HourFormat } from "../../common-data/Converts";
import { fetchReceptionistShiftsData } from "../../../redux/reducers/dropdownApiSlice";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import FormInput from "./components/FormInput";
// import { fetchGymData } from "../../../data/APIs";
import DocumentUploadSection from "./sections/DocumentUploadSection";
import {
  CallIcon,
  EmailIcon,
  PersonIcon,
  BuildingIcon,
  CalendarIcon,
} from "../../../images/icons/icons";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";

const OnboardTrainerForm = ({
  userInfoData,
  rowData,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoadingFormData, loading, data } = useSelector(
    (state) => state.common
  );
  const gymData = useSelector(selectGymData);
  const accountType = rowData?.account_type;
  const isFD = accountType === "receptionist";
  // ||
  // accountType === "sales_manager" ||
  // rowData?.is_cluster_manager
  // const isClusterManager = accountType === "cluster_manager";
  const isMultiGymShow =
    accountType === "cluster_manager" ||
    accountType === "fitness_manager" ||
    accountType === "club_manager" ||
    accountType === "sales_manager";

  const [fetchedShiftDetails, setFetchedShiftDetails] = useState([]);
  const [isLoadingShifts, setIsLoadingShifts] = useState(false);

  const [modValues, setModValues] = useState({
    isModOpen: false,
    rowData: "",
    cardName: "",
    image: "",
  });

  const getFileType = (fileUrl) => {
    if (!fileUrl) return "unknown";
    const decodedUrl =
      typeof fileUrl === "string" ? decodeURIComponent(fileUrl) : fileUrl;
    const extension = decodedUrl.split(".").pop()?.toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension))
      return "image";
    if (extension === "pdf") return "pdf";
    return "unknown";
  };

  const handleFileView = (fileUrl, fileName) => {
    if (!fileUrl) return;

    const fileType = getFileType(fileUrl);
    if (fileType === "image") {
      const decodedImageUrl =
        typeof fileUrl === "string" ? decodeURIComponent(fileUrl) : fileUrl;
      setModValues({
        isModOpen: true,
        cardName: "doc-image",
        image: decodedImageUrl,
        rowData: "",
      });
    } else {
      const link = document.createElement("a");
      link.href =
        typeof fileUrl === "string" ? decodeURIComponent(fileUrl) : fileUrl;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const onCloseModal = () => {
    setModValues({
      isModOpen: false,
      rowData: "",
      cardName: "",
      image: "",
    });
  };

  const fetchShiftDetails = async () => {
    if (!rowData?.shift_id || !userInfoData?.token) return;

    setIsLoadingShifts(true);
    try {
      const filters = {
        page: 1,
        limit: 1000,
        status: "active",
      };

      const result = await dispatch(
        fetchReceptionistShiftsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );

      if (result?.payload && Array.isArray(result.payload)) {
        const shiftIds = rowData.shift_id.split(",");
        const matchingShifts = result.payload.filter((shift) =>
          shiftIds.includes(shift.value)
        );

        setFetchedShiftDetails(matchingShifts);
      }
    } catch (error) {
      console.error("Error fetching shift details:", error);
    } finally {
      setIsLoadingShifts(false);
    }
  };

  const getSelectedGyms = () => {
    if (
      (!rowData?.cm_gyms && !rowData?.fm_gyms) ||
      !gymData ||
      gymData.length === 0
    )
      return [];

    const gymIdsString = rowData?.cm_gyms || rowData?.fm_gyms || "";
    const gymIds = gymIdsString.split(",").filter((id) => id.trim());
    const selectedGyms = gymData.filter((gym) => gymIds.includes(gym?.value));
    return selectedGyms;
  };

  const getShiftIdsFromRowData = (rowData) => {
    if (rowData?.shift_id) {
      return rowData.shift_id;
    }

    if (rowData?.checkedShifts && Array.isArray(rowData.checkedShifts)) {
      return rowData.checkedShifts.toString();
    }

    if (rowData?.shift_details && Array.isArray(rowData.shift_details)) {
      return rowData.shift_details
        .map((shift) => shift.id || shift.shift_id)
        .filter(Boolean)
        .toString();
    }

    return "";
  };

  const handleShiftFormUpdate = async () => {
    const method = "PUT";
    const endpoint = "/user/receptionist";
    const token = userInfoData?.token || "";

    const userData = {
      uid: rowData?.receptionist_uid || "",
      name: rowData?.name || "",
      shift_id: getShiftIdsFromRowData(rowData),
    };

    const formData = new FormData();
    for (const key in userData) {
      if (userData.hasOwnProperty(key)) {
        if (userData[key] instanceof File) {
          formData.append(key, userData[key]);
        } else {
          formData.append(key, userData[key].toString());
        }
      }
    }

    const requestBody = formData;

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleTrainerFormUpdate = async (trainerID) => {
    const method = "PUT";
    const endpoint = update_trainer;
    const token = userInfoData?.token || "";

    const userData = {
      uid: trainerID || "",
      trainer_id: trainerID || "",
      trainer_exp_lvl: rowData?.trainer_exp_lvl || "",
      trainer_category_id: rowData?.trainer_category_id || "",
      gym_id: rowData?.gym_id || "",
      status: "active",
      trainer_lang: "English, Hindi",
      description: "trainer onboarding",
    };

    const formData = new FormData();
    for (const key in userData) {
      if (userData.hasOwnProperty(key)) {
        if (userData[key] instanceof File) {
          formData.append(key, userData[key]);
        } else {
          formData.append(key, userData[key].toString());
        }
      }
    }

    const requestBody = formData;

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleSubmitStaffCTO = async () => {
    const method = "POST";
    const endpoint = add_staff_cto;
    const token = userInfoData?.token || "";

    const userData = {
      mobile: rowData?.mobile || "",
      is_first: 1,
    };

    const payload = userData;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = update_staff_register;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );
      if (result?.payload?.status) {
        closeModal();
        callFunction();
        handleSubmitStaffCTO();
        toast.success(result?.payload?.message || "Success!");

        if (data?.data?.length > 0) {
          const accountType = data.data[0]?.account_type;
          const trainerID = data.data[0]?.uid;

          if (accountType === "trainer" && trainerID) {
            handleTrainerFormUpdate(trainerID);
          }
        }
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleDelete = async (filter, userData) => {
    if (!filter?.uid) {
      toast.error("UID required!");
      return;
    }

    try {
      const response = await dispatch(
        commonDeleteApi({
          TOKEN: userInfoData?.token,
          endpoint: delete_user,
          queryParams: filter,
        })
      ).unwrap();

      if (response?.status) {
        handleSubmitForm(userData);
      } else if (response?.message === "User not found" || response?.message === "User is already deleted") {
        // Nothing to delete in `users` (e.g. a manager tracked only in
        // gym_manager_master / staff_on_boarding, not yet a users row) — proceed
        // with the registration instead of blocking.
        handleSubmitForm(userData);
      } else {
        toast.error(response?.message || "Can not delete!");
      }
    } catch (error) {
      // commonDeleteApi throws a generic "...failed with status 400" on the
      // delete endpoint's not-found / already-deleted cases. That just means there
      // is no users-table row to remove, so continue with the registration.
      if (`${error?.message || ""}`.includes("status 400")) {
        handleSubmitForm(userData);
      } else {
        toast.error(error?.message || "Failed to delete");
      }
    }
  };

  const onSubmit = () => {
    const allGyms =
      rowData?.gyms_info?.length > 0
        ? rowData.gyms_info.map((gym) => gym.gym_id || gym.user_id).join(",")
        : "";

    const userData = {
      approved_by: userInfoData?.uid || userInfoData?.user_id || "",
      salary: rowData?.salary || "",
      shift_id:
        accountType === "receptionist" || accountType === "sales_manager"
          ? getShiftIdsFromRowData(rowData)
          : "",
      cm_gyms: allGyms || "",
      fm_gyms: allGyms || "",

      uid: rowData?.uid || "",
      upi_id: rowData?.upi_id || "",
      account_number: rowData?.account_number || "",
      account_type: rowData?.account_type || "",
      address: rowData?.address || "",
      bank_name: rowData?.bank_name || "",
      date_added: rowData?.date_added || "",
      dob: rowData?.dob || "",
      email: rowData?.email || "",
      emergency_contact: rowData?.emergency_contact || "",
      expertise: rowData?.expertise || "",
      gym_id: rowData?.gym_id || "",
      gym_name: rowData?.gym_name || "",
      gyms_info: rowData?.gyms_info || "",
      id: rowData?.id || "",
      id_card: rowData?.id_card || "",
      ifsc_code: rowData?.ifsc_code || "",
      joining_date: rowData?.joining_date || "",
      last_updated: rowData?.last_updated || "",
      marksheet10: rowData?.marksheet10 || "",
      marksheet12: rowData?.marksheet12 || "",
      mobile: rowData?.mobile || "",
      name: rowData?.name || "",
      pan_card: rowData?.pan_card || "",
      passbook: rowData?.passbook || "",
      photo: rowData?.photo || "",
      postal_code: rowData?.postal_code || "",
      shift_details: rowData?.shift_details || "",
      total_check_in: rowData?.total_check_in || 0,
      payrole_type: "",
      status: "active",
      approval_status: 1,
      trainee_on_boarding: 0,
      is_exists: 0,
    };

    const handleConfirm = async () => {
      handleSubmitForm(userData);
    };

    const handleConfirmDelete = async () => {
      const uidFilter = {
        uid: data?.data[0]?.uid || data?.data[0]?.user_id || "",
      };
      handleDelete(uidFilter, userData);
    };

    if (data?.data?.length > 0) {
      const accountType = data.data[0]?.account_type;
      // Existing role for the confirm message. account_type can be empty for some
      // users (e.g. cluster/club managers stored via role flags), so fall back to
      // those flags, then a generic label — never show "undefined" to the user.
      const existingRole =
        (accountType && accountType.replace(/_/g, " ")) ||
        (data.data[0]?.is_cluster_manager ? "cluster manager" : "") ||
        (data.data[0]?.is_club_manager ? "club manager" : "") ||
        "another account type";

      const isAccountConflicts =
        (accountType === "receptionist" ||
          accountType === "sales_manager" ||
          accountType === "club_manager" ||
          data.data[0]?.is_club_manager) &&
        (rowData?.account_type === "receptionist" ||
          rowData?.account_type === "sales_manager" ||
          rowData?.account_type === "club_manager" ||
          rowData?.is_club_manager);

      const isAccountTypeSame =
        accountType === rowData?.account_type || isAccountConflicts;

      if (isAccountTypeSame) {
        if (isFD) {
          const handleConfirmShift = async () => {
            handleShiftFormUpdate();
          };

          showConfirmAlert(
            handleConfirmShift,
            `Do you want to update the details of ${rowData?.name}?`,
            "Cancel",
            "Update"
          );
        } else {
          showConfirmAlert(
            closeModal,
            `${rowData?.name} already registered as ${existingRole}!`,
            false,
            "Ok",
            true
          );
        }
      } else if (!isAccountTypeSame) {
        showConfirmAlert(
          handleConfirmDelete,
          `This user ${
            rowData?.name
          } is already registered as ${existingRole}. If you wish to register this user as ${rowData?.account_type?.replace(
            /_/g,
            " "
          )}, please click on "Confirm." The existing details will be removed permanently. Click on "Confirm" to proceed.`,
          "Cancel",
          "Confirm"
        );
      }
    } else {
      showConfirmAlert(
        handleConfirm,
        `Please Check Before Submit!`,
        "Edit Form",
        "Submit"
      );
    }
  };

  useEffect(() => {
    if (rowData?.shift_id && accountType === "receptionist") {
      fetchShiftDetails();
    }
  }, []);

  // useEffect(() => {
  //   if (isMultiGymShow && (!gymData || gymData.length === 0)) {
  //     dispatch(fetchGymData(userInfoData?.token));
  //   }
  // }, []);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className="modal-wrapper-no-padding">
          <div
            className={`createNewCTOModalContainer ${
              modValues.cardName === "onboarding"
                ? "mod-width-50p"
                : modValues.cardName === "doc-image"
                ? "modal-container-abs"
                : ""
            }`}
          >
            <ModalHeadAndClose
              title={
                modValues.cardName === "offer_letter"
                  ? "Employee Offer Letter Preview"
                  : ""
              }
              onClose={onCloseModal}
            />
            <div className="grayLine"></div>
            {modValues.cardName === "doc-image" ? (
              <div className="discussionModalMessage mt30">
                <img src={modValues.image} alt={modValues.image} />
              </div>
            ) : null}
          </div>
        </div>
      </Modal>

      <CommonHeadingNBtns
        title={`${accountType?.replace(/_/g, " ")} Onboarding`}
        onClose={closeModal}
        btnTxt="Submit"
        onClick={onSubmit}
        isLoading={postPutLoadingFormData || loading}
      />

      <div className="staff-onboarding-content mt-4">
        <form className="staff-onboarding-form staff-onboarding-form-container">
          <div className="staff-onboarding-form-section">
            <div className="staff-onboarding-section-header">
              <h3 className="staff-onboarding-section-title">
                Contact Information
              </h3>
              <p className="staff-onboarding-section-subtitle">
                Primary contact details
              </p>
            </div>
            <div className="staff-onboarding-section-content">
              <div className="staff-onboarding-form-grid grid-2">
                <FormInput
                  icon={CallIcon}
                  label="Mobile Number"
                  name="staffMobile"
                  type="tel"
                  placeholder="Enter 10-digit mobile number"
                  value={rowData?.mobile || ""}
                  disabled={true}
                  required={true}
                />
                <FormInput
                  icon={EmailIcon}
                  label="Email Address"
                  name="staffEmail"
                  type="email"
                  placeholder="Enter email address"
                  value={rowData?.email || ""}
                  disabled={true}
                  required={true}
                />
              </div>
            </div>
          </div>

          <div className="staff-onboarding-form-section">
            <div className="staff-onboarding-section-header">
              <h3 className="staff-onboarding-section-title">
                Basic Information
              </h3>
              <p className="staff-onboarding-section-subtitle">
                Staff personal and role details
              </p>
            </div>
            <div className="staff-onboarding-section-content">
              <div className="staff-onboarding-form-grid">
                <FormInput
                  icon={PersonIcon}
                  label="Staff Type"
                  name="staffType"
                  type="text"
                  placeholder="Staff Type"
                  value={accountType?.replace(/_/g, " ") || ""}
                  disabled={true}
                />
                {!isMultiGymShow && (
                  <FormInput
                    icon={BuildingIcon}
                    label="Gym Name"
                    name="gymName"
                    type="text"
                    placeholder="Gym Name"
                    value={rowData?.gym_name || ""}
                    disabled={true}
                  />
                )}
                <FormInput
                  icon={PersonIcon}
                  label="Full Name"
                  name="staffName"
                  type="text"
                  placeholder="Enter Full Name"
                  value={rowData?.name || ""}
                  disabled={true}
                />
                <FormInput
                  icon={CallIcon}
                  label="Emergency Contact"
                  name="emergencyContact"
                  type="tel"
                  placeholder="Enter Emergency Contact"
                  value={rowData?.emergency_contact || ""}
                  disabled={true}
                />
                <FormInput
                  icon={CalendarIcon}
                  label="Joining Date"
                  name="joiningDate"
                  type="text"
                  placeholder="Joining Date"
                  value={rowData?.joining_date || ""}
                  disabled={true}
                />
                <FormInput
                  icon={CalendarIcon}
                  label="Date of Birth"
                  name="dob"
                  type="text"
                  placeholder="Date of Birth"
                  value={rowData?.dob || ""}
                  disabled={true}
                />
                <FormInput
                  icon={PersonIcon}
                  label="Full Address"
                  name="address"
                  type="text"
                  placeholder="Enter Full Address"
                  value={rowData?.address || ""}
                  disabled={true}
                  fullWidth={true}
                />
                <FormInput
                  icon={PersonIcon}
                  label="Pin Code"
                  name="pinCode"
                  type="text"
                  placeholder="Enter Pin Code"
                  value={rowData?.postal_code || ""}
                  disabled={true}
                />
                <FormInput
                  icon={PersonIcon}
                  label="Staff Salary"
                  name="staffSalary"
                  type="number"
                  placeholder="Enter Salary"
                  value={rowData?.salary || ""}
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <div className="staff-onboarding-form-section">
            <div className="staff-onboarding-section-header">
              <h3 className="staff-onboarding-section-title">
                Banking Information
              </h3>
              <p className="staff-onboarding-section-subtitle">
                Bank account and payment details
              </p>
            </div>
            <div className="staff-onboarding-section-content">
              <div className="staff-onboarding-form-grid">
                <FormInput
                  icon={PersonIcon}
                  label="Bank Name"
                  name="bankName"
                  type="text"
                  placeholder="Enter Bank Name"
                  value={rowData?.bank_name || ""}
                  disabled={true}
                />
                <FormInput
                  icon={PersonIcon}
                  label="Account Number"
                  name="accountNumber"
                  type="text"
                  placeholder="Enter Account Number"
                  value={rowData?.account_number || ""}
                  disabled={true}
                />
                <FormInput
                  icon={PersonIcon}
                  label="IFSC Code"
                  name="ifscCode"
                  type="text"
                  placeholder="Enter IFSC Code"
                  value={rowData?.ifsc_code || ""}
                  disabled={true}
                />
                <FormInput
                  icon={PersonIcon}
                  label="UPI ID"
                  name="upiID"
                  type="text"
                  placeholder="Enter UPI ID"
                  value={rowData?.upi_id || ""}
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <DocumentUploadSection
            formValues={{
              identityProof: rowData?.id_card || "",
              panCard: rowData?.pan_card || "",
              markSheet10th: rowData?.marksheet10 || "",
              markSheet12th: rowData?.marksheet12 || "",
              staffPhoto: rowData?.photo || "",
              bankDetail: rowData?.passbook || "",
            }}
            onChangeInput={null}
            formErrors={{}}
            assignRef={() => {}}
            isReOnboard={true}
            isEdit={true}
            isApproval={false}
            handleFileView={handleFileView}
            handleFileDelete={null}
          />

          <div className="staff-onboarding-form-section">
            <div className="staff-onboarding-section-header">
              <h3 className="staff-onboarding-section-title">
                HR Approval Settings
              </h3>
              <p className="staff-onboarding-section-subtitle">
                Configure shift timing and trainer details for staff onboarding
              </p>
            </div>

            <div className="staff-onboarding-section-content">
              <div className="staff-onboarding-form-grid">
                {isMultiGymShow && (
                  <div className="staff-onboarding-form-group staff-onboarding-full-width">
                    <label className="staff-onboarding-form-label">
                      <span className="staff-onboarding-label-text">
                        Selected Gyms
                      </span>
                    </label>
                    <div className="staff-onboarding-shift-container">
                      {rowData?.gyms_info?.length > 0 ? (
                        <div className="gym-display-grid">
                          {rowData.gyms_info?.map((gym, index) => (
                            <div key={index} className="gym-display-card">
                              {gym?.gym_name || "NA"}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span className="info">
                          Gym information not available
                        </span>
                      )}

                      {/* {!gymData || gymData.length === 0 ? (
                        <span className="info">Loading gym data...</span>
                      ) : getSelectedGyms().length > 0 ? (
                        <div className="gym-display-grid">
                          {getSelectedGyms().map((gym, index) => (
                            <div key={index} className="gym-display-card">
                              {gym?.label ||
                                gym?.name ||
                                "Gym name not available"}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span className="info">
                          Gym information not available
                        </span>
                      )} */}
                    </div>
                  </div>
                )}

                {accountType === "receptionist" && (
                  <div className="staff-onboarding-form-group staff-onboarding-full-width">
                    <label className="staff-onboarding-form-label">
                      <span className="staff-onboarding-label-text">
                        Shift Timing Information
                      </span>
                    </label>
                    <div className="staff-onboarding-shift-container">
                      {isLoadingShifts ? (
                        <span className="info">Loading shift details...</span>
                      ) : fetchedShiftDetails &&
                        fetchedShiftDetails.length > 0 ? (
                        <div className="shift-display-grid">
                          {fetchedShiftDetails.map((shift, index) => (
                            <div key={index} className="shift-display-card">
                              {shift?.info?.shift_start &&
                              shift?.info?.shift_end
                                ? `${convertTo12HourFormat(
                                    shift.info.shift_start
                                  )} - ${convertTo12HourFormat(
                                    shift.info.shift_end
                                  )}`
                                : shift?.label || "Shift timing not available"}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span className="info">
                          Shift timing information not available
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {accountType === "trainer" && (
                  <div className="staff-onboarding-form-group staff-onboarding-full-width">
                    <label className="staff-onboarding-form-label">
                      <span className="staff-onboarding-label-text">
                        Trainer Shift Timing
                      </span>
                    </label>
                    <div className="trainer-shift-timing-container">
                      <div className="shift-timing-table">
                        <div className="shift-timing-header">
                          <div className="shift-name">Shift Name</div>
                          <div className="shift-time">Start Time</div>
                          <div className="shift-time">End Time</div>
                        </div>

                        <div className="shift-timing-row">
                          <label className="shift-label">Morning</label>
                          <div className="staff-onboarding-time-display">
                            {rowData?.morning_shift_start
                              ? convertTo12HourFormat(
                                  rowData.morning_shift_start
                                )
                              : "Not set"}
                          </div>
                          <div className="staff-onboarding-time-display">
                            {rowData?.morning_shift_end
                              ? convertTo12HourFormat(rowData.morning_shift_end)
                              : "Not set"}
                          </div>
                        </div>

                        <div className="shift-timing-row">
                          <label className="shift-label">Evening</label>
                          <div className="staff-onboarding-time-display">
                            {rowData?.evening_shift_start
                              ? convertTo12HourFormat(
                                  rowData.evening_shift_start
                                )
                              : "Not set"}
                          </div>
                          <div className="staff-onboarding-time-display">
                            {rowData?.evening_shift_end
                              ? convertTo12HourFormat(rowData.evening_shift_end)
                              : "Not set"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default OnboardTrainerForm;
